<template>
  <div class="rfa_container">
    <div class="title">RFA (Overall)</div>
    <div class="top">
      <div class="top_left">
        <div class="top_left_one">
          <div class="top_left_one_type">Open
            <div class="top_left_one_count" style="color:orange">{{ Number(open_count) + Number(overdue_count) }}</div>
          </div>
          <div class="top_left_one_type_small">On-goning
            <div class="top_left_one_count_small" style="color:blue">{{ open_count }}</div>
          </div>
          <div class="top_left_one_type_small">WIP Overdue
            <div class="top_left_one_count_small" style="color:red">{{ overdue_count }}</div>
          </div>
        </div>
        <div class="top_left_two">
          <div class="top_left_two_type">Closed
            <div class="top_left_two_count" style="color:green">{{ closed_count }}</div>
          </div>
          <div class="top_left_two_type" style="color:white;margin-left: 30%">Total
            <div class="top_left_two_count" style="color:white;margin-left: 30%">{{ total_count }}</div>
          </div>

        </div>
      </div>
      <div v-if="piedataNotNull" class="top_right">
        <div style="width: 100%; height: 100%" id="rfa_chart_one"></div>
      </div>
    </div>
    <div class="bottom">
      <div class="bottom_title">RFA-Discipline
        <div class="rfselect"
             style="position: absolute; left: 85%; z-index: 9;width: 10%;">
          <el-select v-model="bar1_tag"
                     placeholder="请选择" popper-class="optionsContent"
                     @change="switch_bar1">
            <el-option
              v-for="item in type_tags"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>

      <div v-if="bar1DataNotNull" class="bottom_content">
        <div style="width: 100%; height: 100%" id="rfa_chart"></div>
      </div>
    </div>
    <div class="bottom">
      <div class="bottom_title">RFA-Group
        <div class="rfselect"
             style="position: absolute; left: 77%; z-index: 9;width: 10%;">
          <el-select v-model="bar2_tag1"
                     placeholder="请选择" popper-class="optionsContent"
                     @change="switch_bar21">
            <el-option
              v-for="item in type_tags"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="rfselect"
             style="position: absolute; left: 85%; z-index: 9;width: 10%;">
          <el-select v-model="bar2_tag2"
                     placeholder="请选择" popper-class="optionsContent"
                     @change="switch_bar22">
            <el-option
              v-for="item in major_tags"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div v-if="bar2DataNotNull" class="bottom_content">
        <div style="width: 100%; height: 100%" id="rfa_chart2"></div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import axios from 'axios'

export default {
  name: "rfa",
  data() {
    return {
      project_id: "",
      open_count: 0,
      closed_count: 0,
      overdue_count: 0,
      total_count: 0,
      piedataNotNull: true,
      bar1DataNotNull: true,
      bar2DataNotNull: true,
      piechart: null,
      barchart1: null,
      barchart2: null,
      bar1_tag: "ALL",
      bar2_tag1: "ALL",
      bar2_tag2: "ALL",
      type_tags: [
        {
          "label": "ALL",
          "value": 0
        },
        {
          "label": "RFA-Dwg",
          "value": "RF00003"
        },
        {
          "label": "RFA-M&E",
          "value": "RF00002"
        },
      ],
      major_tags: [
        {
          "label": "ALL",
          "value": 0
        },
        {
          "label": "Structural",
          "value": 1
        },
        {
          "label": "Architecture",
          "value": 2
        },
        {
          "label": "MEP",
          "value": 3
        },
      ],
      status_list: {
        "0": "Open",
        "1": "Closed",
        "2": "Overdue"
      },
      type_list: {
        "1": "Structural",
        "2": "Architecture",
        "3": "MEP"
      }
    }
  },
  mounted() {
    this.drawBar()
    this.get_rfstate(0)
    this.get_rfdiscipline()
    this.get_rfcompany()
  },
  beforeDestroy() {
    if (this.piechart) {
      this.piechart.clear()
    }
    if (this.barchart1) {
      this.barchart1.clear()
    }
    if (this.barchart2) {
      this.barchart2.clear()
    }
  },
  methods: {
    getNowFormatDate() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    switch_bar1(label) {
      this.get_rfdiscipline(label)
    },
    switch_bar21(label) {
      this.bar2_tag2 = "ALL"
      this.get_rfcompany(label)
    },
    switch_bar22(label) {
      this.bar2_tag1 = "ALL"
      this.get_rfcompany(0, label)
    },
    init() {
      this.project_id = this.$route.query.proj_id
    },
    get_rfstate(rtype) {
      let that = this
      that.date = this.getNowFormatDate()
      let postData = {
        project_id: that.project_id,
        user: window.localStorage.getItem("token_key"),
        token: "lalala",
        type: "2",
        rtype: rtype
        // startdate: that.date,
        // enddate: that.date
      }
      axios.post(this.$store.getters.getCmsServer + "DBProjRFstate", postData).then(resp => {
        var errNo = resp.data.errno
        var errStr = resp.data.errstr_cn
        if (errNo == "0") {
          this.piedataNotNull = true
          var result = resp.data.result;
          for (var i in result) {
            if (result[i].status == '0') {
              that.open_count = result[i].count
            } else if (result[i].status == '1') {
              that.closed_count = result[i].count
            } else if (result[i].status == '2') {
              that.overdue_count = result[i].count
            }
          }
          that.total_count = Number(that.open_count) + Number(that.closed_count) + Number(that.overdue_count)
          var pieData = [Number(that.closed_count), Number(that.open_count) + Number(that.overdue_count)]
          that.piechart.setOption({
            series: [
              {
                data: pieData
              },
            ]
          })
        } else {
          this.piedataNotNull = false
        }
      }).catch(error => {
        this.piedataNotNull = false
      })
    },
    get_rfdiscipline(form_id) {
      var that = this
      that.date = this.getNowFormatDate()
      let postData = {
        project_id: that.project_id,
        user: window.localStorage.getItem("token_key"),
        token: "lalala",
        type: "2",
        form_id: form_id
        // startdate: that.date,
        // enddate: that.date
      }
      axios.post(this.$store.getters.getCmsServer + "DBProjRFdiscipline", postData).then(resp => {
        var errNo = resp.data.errno
        var errStr = resp.data.errstr_cn
        if (errNo == "0") {
          this.bar1DataNotNull = true
          var result = resp.data.result;
          // 1-Structural 2-Architecture 3-MEP
          var open = [0, 0, 0, 0, 0, 0]
          var closed = [0, 0, 0, 0, 0, 0]
          var overdue = [0, 0, 0, 0, 0, 0]
          var total = [0, 0, 0, 0, 0, 0]
          for (var i in result) {
            if (result[i].status == '0') {
              open[Number(result[i].discipline) - 1] = result[i].count
              total[Number(result[i].discipline) - 1] += Number(result[i].count)
            } else if (result[i].status == '1') {
              closed[Number(result[i].discipline) - 1] = result[i].count
              total[Number(result[i].discipline) - 1] += Number(result[i].count)
            } else if (result[i].status == '2') {
              overdue[Number(result[i].discipline) - 1] = result[i].count
              total[Number(result[i].discipline) - 1] += Number(result[i].count)
            }
          }
          that.total_count = Number(that.open_count) + Number(that.closed_count) + Number(that.overdue_count)
          var barData1 = [Number(that.closed_count), Number(that.open_count)]

          that.barchart1.setOption({
            series: [
              {
                data: closed
              },
              {
                data: open
              },
              {
                data: overdue
              },
              {
                data: total
              },
            ]
          })
        } else {
          this.bar1DataNotNull = false
        }
      }).catch(error => {
        this.bar1DataNotNull = false
      })
    },
    get_rfcompany(form_id, major_id) {
      var that = this
      that.date = this.getNowFormatDate()
      let postData = {
        project_id: that.project_id,
        user: window.localStorage.getItem("token_key"),
        token: "lalala",

        type: "2",
        form_id: form_id,
        major_id: major_id
        // startdate: that.date,
        // enddate: that.date
      }
      axios.post(this.$store.getters.getCmsServer + "DBProjRFComState", postData).then(resp => {
        var errNo = resp.data.errno
        var errStr = resp.data.errstr_cn
        if (errNo == "0") {
          this.bar2DataNotNull = true
          that.$nextTick().then(() => {
            that.drawBar2()
            var result = resp.data.result;
            // 1-Structural 2-Architecture 3-MEP
            var open = [0, 0, 0]
            var closed = [0, 0, 0]
            var overdue = [0, 0, 0]
            var total = [0, 0, 0]
            var com_list = []
            var contractor_name = ''
            for (var i in result) {
              if (!result[i].contractor_name || result[i].contractor_name == '') {
                contractor_name = result[i].cname
              } else {
                contractor_name = result[i].contractor_name
              }
              let index = com_list.indexOf(contractor_name)

              if (index < 0) {
                com_list.push(contractor_name)
              }
              index = com_list.indexOf(contractor_name)
              if (result[i].status === '0') {
                open[index] = Number(result[i].count)
                total[index] += Number(result[i].count)
              } else if (result[i].status === '1') {
                closed[index] = Number(result[i].count)
                total[index] += Number(result[i].count)
              } else if (result[i].status === '2') {
                overdue[index] = Number(result[i].count)
                total[index] += Number(result[i].count)
              }
            }
            that.barchart2.setOption({
              yAxis: {
                data: com_list
              },
              series: [
                {
                  data: closed
                },
                {
                  data: open
                },
                {
                  data: overdue
                },
                {
                  data: total
                },
              ]
            })
          })
        } else {
          this.bar2DataNotNull = false
        }
      }).catch(error => {
        this.bar2DataNotNull = false
      })

    },
    drawBar() {
      this.drawchart()
      this.drawBar1()
      this.drawBar2()
    },
    drawchart() {
      var that = this
      //pie chart
      this.piechart = echarts.init(document.getElementById('rfa_chart_one'))
      this.piechart.setOption({
        series: [{
          name: '',
          type: 'pie',
          radius: ['55%', '95%'],
          data: [],
          label: {
            normal: {
              show: true,
              position: 'inner',
              formatter: '{d}%',
              textStyle: {
                fontSize: '12',
                color: 'white'
              }
            },
            emphasis: {
              show: true,
              textStyle: {
                fontSize: '16',
              }
            }
          },
          itemStyle: {
            normal: {
              color: function (params) {
                return ['#70AB46', '#FFA500'][params.dataIndex]
              }
            },
            //鼠标悬停时：
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
              borderWidth: 1,
            }
          },
        }]
      })
    },
    drawBar1() {
      //bar1
      this.barchart1 = echarts.init(document.getElementById('rfa_chart'))
      this.barchart1.setOption({
        grid: {
          left: '5%',
          right: '8%',
          bottom: '2%',
          top: 0,
          containLabel: true
        },
        xAxis: {
          type: 'value',
          axisLabel: {
            show: false,
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'category',
          data: ['Strcutural', 'Architectural', 'MEP'],
          axisLabel: {
            show: true,
            color: 'white'
          },
          axisLine: {
            lineStyle: {
              color: '#666666',
              width: 1
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          }
        },
        series: [
          {
            type: 'bar',
            stack: '总量',
            label: {
              normal: {
                show: true,
                color: 'white',
                fontSize: 12,
                formatter: function (params) {
                  if (params.value > 0) {
                    return params.value
                  } else {
                    return ""
                  }
                }
              }
            },
            data: [],
            barWidth: 20,
            itemStyle: {
              normal: {
                color: 'green'
              },
            }
          },
          {
            type: 'bar',
            stack: '总量',
            label: {
              normal: {
                show: true,
                color: 'white',
                fontSize: 12,
                formatter: function (params) {
                  if (params.value > 0) {
                    return params.value
                  } else {
                    return ""
                  }
                }
              }
            },
            data: [],
            barWidth: 20,
            itemStyle: {
              normal: {
                color: 'blue'
              },
            }
          },
          {
            type: 'bar',
            stack: '总量',
            label: {
              normal: {
                show: true,
                color: 'white',
                fontSize: 12,
                formatter: function (params) {
                  if (params.value > 0) {
                    return params.value
                  } else {
                    return ""
                  }
                }
              }
            },
            data: [],
            barWidth: 20,
            itemStyle: {
              normal: {
                color: 'red'
              },
            }
          },
          {
            type: 'line',
            stack: 'total',
            data: [],
            symbol: 'pin',
            symbolSize: 1,
            lineStyle: {
              normal: {
                width: 0
              }
            },
            label: {
              normal: {
                show: true,
                color: 'white',
                position: 'right',
                fontSize: 12,
                formatter: function (params) {
                  if (params.value > 0) {
                    return params.value
                  } else {
                    return ""
                  }
                }
              }
            },
          }
        ]
      })
    },
    drawBar2() {//bar2
      this.barchart2 = echarts.init(document.getElementById('rfa_chart2'))
      this.barchart2.setOption({
        grid: {
          left: '5%',
          right: '8%',
          bottom: '2%',
          top: 0,
          containLabel: true
        },
        xAxis: {
          type: 'value',
          axisLabel: {
            show: false,
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'category',
          data: [],
          axisLabel: {
            show: true,
            color: 'white',
            formatter: function (params) {
              if (params.length > 40) {
                return params.substring(0, 20) + '\n' + params.substring(20, 40) + '\n' + params.substring(40, params.length)
              } else {
                if (params.length > 20) {
                  return params.substring(0, 20) + '\n' + params.substring(20, params.length)
                } else {
                  return params
                }
              }
            }
          },
          axisLine: {
            lineStyle: {
              color: '#666666',
              width: 1
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          }
        },
        series: [
          {
            type: 'bar',
            stack: '总量',
            label: {
              normal: {
                show: true,
                color: 'white',
                fontSize: 12,
                formatter: function (params) {
                  if (params.value > '0') {
                    return params.value
                  } else {
                    return ""
                  }
                }
              }
            },
            data: [],
            barWidth: 20,
            itemStyle: {
              normal: {
                color: 'green'
              },
            }
          },
          {
            type: 'bar',
            stack: '总量',
            label: {
              normal: {
                show: true,
                color: 'white',
                fontSize: 12,
                formatter: function (params) {
                  if (params.value > '0') {
                    return params.value
                  } else {
                    return ""
                  }
                }
              }
            },
            data: [],
            barWidth: 20,
            itemStyle: {
              normal: {
                color: 'blue'
              },
            }
          },
          {
            type: 'bar',
            stack: '总量',
            label: {
              normal: {
                show: true,
                color: 'white',
                fontSize: 12,
                formatter: function (params) {
                  if (params.value > '0') {
                    return params.value
                  } else {
                    return ""
                  }
                }
              }
            },
            data: [],
            barWidth: 20,
            itemStyle: {
              normal: {
                color: 'red'
              },
            }
          },
          {
            type: 'line',
            data: [],
            symbol: 'pin',
            symbolSize: 1,
            lineStyle: {
              normal: {
                width: 0
              }
            },
            label: {
              normal: {
                show: true,
                color: 'white',
                position: 'right',
                fontSize: 12,
                formatter: function (params) {
                  if (params.value > '0') {
                    return params.value
                  } else {
                    return ""
                  }
                }
              }
            },
          }
        ]
      })
    },
  },
  created() {
    this.init()
  }
}
</script>

<style scoped>
.rfa_container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.title {
  height: 5%;
  font-size: 1rem;
  margin-left: 0.5rem;
  color: white;
  text-align: left;
  display: flex;
  align-items: center;
}

.top {
  width: 100%;
  height: 35%;
  display: flex;
}

.top_left {
  height: 100%;
  width: 60%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}

.top_left_one {
  margin-top: 5%;
  margin-left: 1%;
  width: 100%;
  display: flex;
  border: 1px solid #AAAAAA
}

.top_left_two {
  margin-top: 5%;
  margin-left: 1%;
  width: 100%;
  display: flex;
  border-width: 2px;
  border-color: #ccc;
}

.top_left_one_type {
  margin-left: 12%;
  font-size: 1rem;
  color: white;
  height: 40%;
  text-align: left;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.top_left_one_count {
  margin-top: 20%;
  margin-left: 70%;
  height: 60%;
  width: 100%;
  font-size: 1.4rem;
  /*display: flex;*/
  align-items: center;
  justify-content: center;
}

.top_left_two_type {
  margin-left: 12%;
  font-size: 1rem;
  color: white;
  height: 40%;
  text-align: left;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.top_left_two_count {
  margin-top: 20%;
  margin-left: 70%;
  height: 60%;
  width: 100%;
  font-size: 1.4rem;
  /*display: flex;*/
  align-items: center;
  justify-content: center;
}

.top_left_one_type_small {
  margin-top: 2%;
  margin-left: 15%;
  font-size: 0.8rem;
  color: white;
  height: 40%;
  text-align: left;
  align-items: center;
}

.top_left_one_count_small {
  margin-top: 5%;
  font-size: 1.2rem;
  color: white;
  height: 40%;
  align-items: center;
}

.top_right {
  width: 32%;
  height: 90%;
  margin-top: 2%;
  /*background-color: white;*/
}

.bottom {
  width: 100%;
  height: 60%;
  display: flex;
  flex-direction: column;
}

.bottom_title {
  margin-left: 0.5rem;
  height: 20%;
  display: flex;
  align-items: center;
  color: white;
  font-size: 1rem;
}

.bottom_content {
  width: 100%;
  height: 70%;
}
</style>



// WEBPACK FOOTER //
// src/outside/rfirfa/rfa.vue